var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCtr = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M1 6h25"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3,
  x: 2,
  y: 4.5,
  fill: "currentColor",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3,
  x: 9,
  y: 4.5,
  fill: "currentColor",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3,
  x: 16,
  y: 4.5,
  fill: "currentColor",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3,
  x: 23,
  y: 4.5,
  fill: "currentColor",
  rx: 0.8
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(2 6)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.749,
  height: 7.779,
  x: -0.874,
  y: 7.611,
  strokeWidth: 1.5,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 11v4M6 12v3M10 11v4M14 12v3M17.5 11v4M21 12v3"
})))));
export { SvgToolCtr as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-ctr.svg";